// extracted by mini-css-extract-plugin
export default {"addBtn":"SubTopics_addBtn__Gq4an","sortHelper":"SubTopics_sortHelper__L5dGB"};